import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddMic';
import { useAuthValidation } from '../../utils/hooks';

const AddMicPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddMicPage;
